import React, { useEffect, useRef } from "react";
// ysjeon | aframe 의존성 문제로 임시 주석 처리
// import { ForceGraph2D } from "react-force-graph";
import * as XLSX from "xlsx";
import { useStateContext } from "../contexts/ContextProvider";
import { fileNamePatternSentiment, fileNamePatternIntent } from "../data/dummy";

const Wordnetwork = ({
  id,
  keywordColors,
  initializeGraphData,
  graphData,
  intentIndex,
  sentimentIndex,
}) => {
  const containerRef = useRef();
  const graphRef = useRef();
  const { currentColor } = useStateContext();

  useEffect(() => {
    const fetchData = async () => {
      console.log(`Sentiment: ${fileNamePatternSentiment[sentimentIndex]}`);
      console.log(`Intent: ${fileNamePatternIntent[intentIndex]}`);
      try {
        const filePath = `/data/demo_network/network_${fileNamePatternSentiment[sentimentIndex]}_${fileNamePatternIntent[intentIndex]}_tot_1732590227.csv`;

        const response = await fetch(filePath);
        if (!response.ok) throw new Error(`Failed to load file: ${filePath}`);
        const arrayBuffer = await response.arrayBuffer();
        const workbook = XLSX.read(arrayBuffer, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        const [headers, ...rows] = jsonData;

        if (!headers || headers.length === 0) {
          initializeGraphData({
            nodes: [{ id: "No Data", group: 1 }],
            links: [],
          });
          return;
        }

        // 노드 생성
        const nodes = headers.slice(1).map((header, index) => ({
          id: header,
          group: Math.floor(index / 5),
          frequency: 0, // 초기 등장 횟수는 0
        }));

        const links = [];
        rows.forEach((row, rowIndex) => {
          row.slice(1).forEach((value, colIndex) => {
            if (value > 0 && rowIndex !== colIndex) {
              links.push({
                source: headers[rowIndex + 1],
                target: headers[colIndex + 1],
                value: value,
                color: keywordColors[headers[rowIndex + 1]] || "rgba(50, 150, 250, 0.8)",
              });

              // 등장 횟수 증가
              const sourceNode = nodes.find((node) => node.id === headers[rowIndex + 1]);
              const targetNode = nodes.find((node) => node.id === headers[colIndex + 1]);
              if (sourceNode) sourceNode.frequency += value;
              if (targetNode) targetNode.frequency += value;
            }
          });
        });

        initializeGraphData({ nodes, links });

        setTimeout(() => {
          graphRef.current.zoom(4, 400); // 줌 레벨 조정
        }, 500);
      } catch (error) {
        console.error(`Error loading data for ${id}:`, error);
        initializeGraphData({
          nodes: [{ id: `Error loading data for ${id}`, group: 1 }],
          links: [],
        });
      }
    };

    fetchData();
  }, [intentIndex, sentimentIndex, id]); // intentIndex와 sentimentIndex 추가

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: "500px",
        overflow: "hidden",
      }}
    >
      {/* ysjeon | aframe 의존성 문제로 임시 주석 처리 */}
      {/* <ForceGraph2D
        ref={graphRef}
        width={containerRef.current?.offsetWidth || 800}
        height={containerRef.current?.offsetHeight || 800}
        graphData={graphData}
        d3AlphaMin={0.01}
        d3VelocityDecay={1}
        enableNodeDrag={true}
        enableZoomPanInteraction={false}
        nodeAutoColorBy="group"
        linkDirectionalParticles={0}
        nodeCanvasObject={(node, ctx, globalScale) => {
          const label = node.id;
          const nodeSize = Math.sqrt(node.frequency || 1) * 0.4; // 등장 횟수 기반 노드 크기
          const fontSize = Math.sqrt(node.frequency || 1) * 1.2 / globalScale; // 등장 횟수 기반 텍스트 크기

          ctx.font = `${fontSize}px Sans-Serif`;
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";

          // 노드 원 그리기
          ctx.beginPath();
          ctx.arc(node.x, node.y, nodeSize, 0, 2 * Math.PI, false);
          ctx.fillStyle = keywordColors[node.id] || "rgb(211,211,211)"; // keywordColors로부터 색상 가져오기
          ctx.fill();

          // 라벨 그리기
          ctx.fillStyle = "black"; // 텍스트 색상
          ctx.fillText(label, node.x, node.y);
        }}
        linkWidth={(link) => Math.sqrt(link.value)}
        linkColor={(link) => currentColor} // 링크 색상 설정
      /> */}
      
      {/* 임시 대체 컴포넌트 */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100%',
        backgroundColor: '#f5f5f5',
        borderRadius: '8px',
        border: '2px dashed #ccc'
      }}>
        <p style={{ color: '#666', fontSize: '16px' }}>
          네트워크 그래프 컴포넌트 (aframe 의존성 문제로 임시 비활성화)
        </p>
      </div>
    </div>
  );
};

export default Wordnetwork;
